import {
  Button,
  Dialog,
  DialogContent,
  styled,
  TextField,
  Typography,
} from "@material-ui/core";
import { DeleteOutline } from "@material-ui/icons";
import { brand } from "../theme";

export const Modal = styled(Dialog)({
  "& .MuiPaper-root": {
    borderRadius: 16,
    padding: 0,
    maxWidth: 420,
    width: "100%",
  },
});

export const Content = styled(DialogContent)(({ theme }) => ({
  padding: theme.spacing(4, 3, 3, 3),
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
}));

export const IconCircle = styled("div")({
  width: 72,
  height: 72,
  borderRadius: "50%",
  background: brand.errorBg,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  "& svg": {
    fontSize: 36,
    color: brand.error,
  },
});

export const TrashIcon = DeleteOutline;

export const Title = styled(Typography)(({ theme }) => ({
  fontSize: 22,
  fontWeight: 800,
  color: brand.text,
  marginTop: theme.spacing(2),
  textAlign: "center",
}));

export const Body = styled(Typography)(({ theme }) => ({
  fontSize: 15,
  color: brand.textSec,
  marginTop: theme.spacing(1.5),
  textAlign: "center",
  lineHeight: 1.5,
  "& strong": {
    color: brand.text,
    fontWeight: 700,
  },
}));

export const ConfirmHelp = styled(Typography)(({ theme }) => ({
  fontSize: 13,
  color: brand.textSec,
  marginTop: theme.spacing(3),
  alignSelf: "stretch",
  "& strong": {
    color: brand.error,
    fontWeight: 800,
    letterSpacing: 0.6,
  },
}));

export const ConfirmInput = styled((p: any) => (
  <TextField
    variant="outlined"
    margin="none"
    fullWidth
    autoComplete="off"
    placeholder="DELETE"
    inputProps={{ "data-testid": "delete-confirm-input" }}
    {...p}
  />
))(({ theme }) => ({
  marginTop: theme.spacing(1),
  "& input": {
    fontWeight: 800,
    letterSpacing: 1.2,
    color: brand.text,
  },
  "& input::placeholder": {
    fontWeight: 800,
    letterSpacing: 1.2,
    color: brand.textDis,
    opacity: 1,
  },
}));

export const ConfirmButton = styled((p: any) => <Button {...p} />)(
  ({ theme }) => ({
    marginTop: theme.spacing(3),
    width: "100%",
    height: 48,
    borderRadius: 12,
    fontSize: 14,
    fontWeight: 800,
    letterSpacing: 0.8,
    textTransform: "uppercase",
    background: brand.error,
    color: brand.white,
    boxShadow: "none",
    "&:hover": {
      background: brand.error,
      opacity: 0.9,
      boxShadow: "none",
    },
    "&.Mui-disabled": {
      background: "#F5C5C5",
      color: brand.white,
    },
  })
);

export const CancelButton = styled((p: any) => <Button {...p} />)(
  ({ theme }) => ({
    marginTop: theme.spacing(1.5),
    width: "100%",
    height: 44,
    borderRadius: 12,
    fontSize: 14,
    fontWeight: 800,
    letterSpacing: 0.8,
    textTransform: "uppercase",
    color: brand.text,
    background: "transparent",
    boxShadow: "none",
    "&:hover": {
      background: "transparent",
    },
  })
);
